<template>
  <div class="relative mb-[72px]">
    <input type="text" class="w-full h-[50px] bg-white rounded-[15px] border shadow-md focus:outline-none border-blue-800 pr-10 pl-4" placeholder="Введите запрос">
    <div class="absolute inset-y-0 right-0 flex items-center pr-3">
      <button><img src="../../assets/icons/SearchIco.png" alt=""></button>
    </div>
  </div>
</template>